import React, { useEffect,useState } from "react";
import './css/Home.css';
import { AlignJustify,ChevronRightIcon,Club,Settings, Users } from 'lucide-react';
import NoFeeAlert from '../components/NoFeeAlert';
import Subjects from '../components/Subjects';
import AttendanceCalendar from '../components/AttendanceCalendar';
import HomeAttendance from "../components/HomeAttendance";
import axios from "./../axios";
import { useNavigate } from "react-router-dom";
import Alert from "./Alert2";

const Home = ({setSideBar,setSettingDrawer,open_attendance, setOpen_attendance})=>{
    
    const [student,setStudent] = useState(JSON.parse(localStorage.getItem('student')));
    const school = JSON.parse(localStorage.getItem('school'));
//    console.log('dsad'+JSON.parse(localStorage.getItem('student')));
const isInWebView = typeof window.ReactNativeWebView !== 'undefined';
const navigate = useNavigate();
useEffect(() => {
  const fcm_token = localStorage.getItem('fcm_token');
  const app_name = localStorage.getItem('app_name');
  const is_fcm_done = localStorage.getItem('is_stufcm_done');

  const saveFCM = async () => {
    try {
        const token = localStorage.getItem("student_token"); // or pass from props/context

      
      await axios.get('student/save_fcm', {
        params: {
         
          token: fcm_token,
          app_name: app_name
        },
         headers: {
          Authorization: `Bearer ${token}`, // ✅ clean header
        },
      });
      localStorage.setItem('is_stufcm_done', 1);
    } catch (error) {
      console.error('❌ FCM Save failed:', error);
    }
  };
 
  if ( !is_fcm_done) {
    saveFCM();
  }
}, []);
useEffect(() => {
  
  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("student_token"); // or pass from props/context

      const response = await axios.get('student/profile', {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ clean header
        },
      });
      if(response.data.school_status === 0){
        alert('Your school account is deactivated. Please contact administration.');
        // Optionally, you can log the user out or redirect them
           localStorage.removeItem('student_token');
           localStorage.removeItem('is_stufcm_done');
  navigate('/');

      }
      
      console.log(response.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  fetchProfile();
}, []);

      return(<>

   <div className="top_bar">
 <svg className="home_bg" viewBox="0 0 500 100" preserveAspectRatio="none" style={{ transform: 'rotate(180deg)', display: 'block', width: '100%', height: '189px' }} > <defs> <linearGradient id="gradient" x1="0" y1="0" x2="1" y2="1"> <stop offset="0%" stopColor="#a1c4fd" /> <stop offset="100%" stopColor="#c2e9fb" /> </linearGradient> </defs> <path d="M0,40 C150,80 350,0 500,40 L500,100 L0,100 Z" fill="url(#gradient)" /> </svg>
 <div className="top_bar_items">
        <div className="top-menu-bar">
 <svg onClick={()=>setSideBar(true)} width="24" height="24" viewBox="0 0 24 24" fill="#333" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="3" width="8" height="8" rx="2"/>
  <rect x="14" y="3" width="8" height="8" rx="2"/>
  <rect x="3" y="14" width="8" height="8" rx="2"/>
  <rect x="14" y="14" width="8" height="8" rx="2"/>
</svg>

            <div style={{fontSize:'20px'}}>{school.school_name}</div>
            <Settings onClick={()=>setSettingDrawer(true)}/>
        </div>

        <div className="user-area">
            <div className="Avtar">
               <img src={student.pic != '' ?`https://new.proschoolerp.com/${student.pic}`:'https://www.shutterstock.com/image-vector/vector-funny-cat-glasses-cute-600nw-2313634279.jpg'}/> 
            </div>
            <div className="user-info">
                <div className="plate">
                {student.name}
                <br/>
                Class: {student.class}-{student.section}
                <br/>
                Session: {student.session}
                </div>
            </div>
        </div>
 </div>
 </div> 

 {student.uid==11 && (
    <div className="alert alert-warning" role="alert" style={{margin:'10px'}}>
    <button
      style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', background: '#dc4e4eff', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer', color: 'white', fontWeight: 'bold' }}
      onClick={() => window.location=('https://portal.mdnkalayat.com#open_in_browser')}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
        <polyline points="15 3 21 3 21 9"/>
        <line x1="10" y1="14" x2="21" y2="3"/>
      </svg>
      Go to MDN Digital
    </button>
  </div>
 )}
 <NoFeeAlert/>

 <Subjects/>
<HomeAttendance open={open_attendance}  setOpen={setOpen_attendance}/>
<div onClick={()=>navigate("/student/house-club-activity")} style={{ padding: '10px', margin: '10px' }}>
  <button style={{display:'flex',justifyContent:'space-between',alignItems:'center', width: '100%', padding: '12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}>
 <Users/>   House/Club Activities <ChevronRightIcon/>
  </button>
</div>
<center>
  <h2 > Alerts</h2>
</center>
<Alert/>
     </>);
}
export default Home;